// extracted by mini-css-extract-plugin
export default {"container":"layout_container__yhbeL","header":"layout_header__v5kIT","content":"layout_content__O5kiJ"};